import { getDisplayMode } from "./libs";
import setHeroSlider from "./setHeroSlider";
import gsap from "gsap";

const setHeroVideo = () => {
  const first = document.querySelector('.hero__img.first'),
    video = document.querySelector('.hero__video'),
    last = document.querySelector('.hero__img.last');

  if (video) {
    video.src = getDisplayMode() == 1 ? video.dataset.src : video.dataset.srcSp;
    video.load();

    video.addEventListener('canplaythrough', () => {
      gsap.to(first, {
        autoAlpha: 0,
        duration: 0.8,
        ease: 'sine.inOut'
      })
      gsap.to(video, {
        autoAlpha: 1,
        duration: 0.8,
        ease: 'sine.inOut'
      })
      video.play();
    }, { once: true });

    video.addEventListener('ended', () => {
      gsap.to(video, {
        autoAlpha: 0,
        duration: 0.8,
        ease: 'sine.inOut',
        onComplete: () => {
          video.pause();
          video.removeAttribute('src');
          video.load();
          setHeroSlider();
        }
      })
      gsap.to(last, {
        autoAlpha: 1,
        duration: 0.8,
        ease: 'sine.inOut'
      })
    });
  } else {
    gsap.to(last, {
      autoAlpha: 1,
      duration: 0.8,
      ease: 'sine.inOut',
      onComplete: () => {
        setHeroSlider();
      }
    })
  }

};

export default setHeroVideo;